import { KeyContactsList } from "./KeyContactsList";

export default KeyContactsList;
